import React from "react";
import PropTypes from "prop-types";
import logo from "Resources/ImagesNew/logo.png";
import logo1 from "Resources/Images/logont_68_37.jpg"
import 'Resources/Css/bootstrap.min.css'
import 'Resources/Css/StyleSheet.css'
import 'Resources/Css/css.css'
import 'Resources/Css/css1.css'
import 'react-widgets/dist/css/react-widgets.css'
import phone from "Resources/ImagesNew/iconPhone.png";
import facebook from "Resources/ImagesNew/facebookIcon.png";
import zalo from "Resources/ImagesNew/zaloIcon.png";
class HeaderNoLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }


    render() {
        return (
            <div className="left-header-new header-ver2">
                <div className="searchNew">
                    <div className="row">
                        <div className="col-md-8">
                            <div class="input-group-prepend">
                                <div class="img">
                                    <img src={logo} alt="" width="auto" height="45px" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">

                            <div class="input-group-prepend" style={{ justifyContent: "flex-end" }}>

                                <div className="formHotLine-ver2">
                                    <div className="nav-item-new text-phone-new">
                                        <div className="iconHotlinePhone">
                                            <img src={phone} alt="" />
                                        </div>

                                        <a href="tel:0328666932" alt="" target="_blank">
                                            <span>0328 666 932</span>
                                        </a>
                                    </div>

                                    <div className="nav-item-new" style={{ marginLeft: "0" }}>
                                        <a
                                            href="https://www.facebook.com/groups/PhanmembanhangNiemTin"
                                            alt=""
                                            target="_blank"
                                        >
                                            <img src={facebook} alt="" />
                                        </a>
                                    </div>
                                    <div className="nav-item-new" style={{ marginLeft: "0" }}>
                                        <a href="http://zalo.me/0862505355" alt="" target="_blank">
                                            <img src={zalo} alt="" />
                                        </a>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>



                </div>
            </div>

        );
    };
}
HeaderNoLogin.propTypes = {
    showBackground: PropTypes.bool,
    isNotBranchTong: PropTypes.bool,
    isBranch: PropTypes.bool,
    isDisable: PropTypes.bool,
};

export default HeaderNoLogin;
